import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app';

export default defineNuxtPlugin((nuxtApp) => {
  // NOTE: `vueApp.config.performance` only has an effect in Vue's development
  // build; in a production build the tracing is compiled out, so this is a
  // no-op in prod even when the timer is enabled.
  if (useRuntimeConfig().public.awIsDbgTimerEnabled) {
    // For how app.config.performance works see:
    // https://vuejs.org/api/application.html#app-config-performance
    nuxtApp.vueApp.config.performance = true;
    /* nuxtApp.vueApp.mixin({
      mounted () {
        const componentName = this.$options.name || this.$options.__name;
        console.log(componentName);
        // onServerPrefetch
        // https://vuejs.org/api/composition-api-lifecycle#onserverprefetch
      },
    }); */
  }
});
